// Base pública do tema em produção (prefixo absoluto no servidor)
// 2ECOMP: O Traccar serve temas em /themes (não /web/themes)
const THEMES_PUBLIC_BASE = '/themes';

const extractCode = (revendaOrCode) => {
  if (!revendaOrCode) return 'default';
  if (typeof revendaOrCode === 'string') return revendaOrCode;
  if (typeof revendaOrCode === 'object' && typeof revendaOrCode.code === 'string') {
    return revendaOrCode.code;
  }
  return 'default';
};

const asString = (value) => (typeof value === 'string' && value.trim().length ? value.trim() : null);
const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value);
const isRootRelative = (value) => typeof value === 'string' && value.startsWith('/');
const sanitizeSegment = (value) => value.replace(/^[./\\]+/, '');

export const getThemePaths = (revendaOrCode) => {
  const code = extractCode(revendaOrCode);
  const base = `${THEMES_PUBLIC_BASE}/${code}`;
  const revenda = typeof revendaOrCode === 'object' && revendaOrCode ? revendaOrCode : {};

  const backgroundLightCandidate = asString(revenda.backgroundLight);
  const backgroundDarkCandidate = asString(revenda.backgroundDark);
  const logoLightCandidate = asString(revenda.logoLightPublic || revenda.logoPublic || revenda.logo);
  const logoDarkCandidate = asString(revenda.logoDarkPublic || revenda.logoDark);

  const resolve = (candidate, fallback) => {
    if (!candidate) return fallback;
    if (isAbsoluteUrl(candidate) || isRootRelative(candidate)) {
      return candidate;
    }
    return `${base}/${sanitizeSegment(candidate)}`;
  };

  const backgroundLight = resolve(backgroundLightCandidate, `${base}/imagens/light-background.webp`);
  const backgroundDark = resolve(backgroundDarkCandidate, `${base}/imagens/dark-background.webp`);
  const logoLight = resolve(logoLightCandidate, `${base}/logo.svg`);
  const logoDark = resolve(logoDarkCandidate, `${base}/logoInverted.svg`);

  return {
    base,
    backgroundLight,
    backgroundDark,
    light: backgroundLight,
    dark: backgroundDark,
    logoLight,
    logoDark,
    logo: logoLight,
    logoLightPublic: logoLight,
    logoDarkPublic: logoDark,
  };
};
